import { forwardRef } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { BeneficiaryGroup as BeneficiaryGroupType } from '@/shared/lib/sj-orm';
import { BaseProps } from '@/shared/types';

import { BeneficiaryGroupI18n } from './BeneficiaryGroupI18n';

type SelectPidTypeV2Props = BaseProps<{
  onSelect: (group: BeneficiaryGroupType) => void;
}>;

const groupsList = [
  BeneficiaryGroupType.FAMILY,
  BeneficiaryGroupType.FAMILY_CLAN,
  BeneficiaryGroupType.CIRCLE,
];

export const SelectBeneficiaryGroupV2 = forwardRef<HTMLDivElement, SelectPidTypeV2Props>(
  ({ onSelect, ...props }, ref) => {
    return (
      <Container {...props} className="uikitScrollbarNone" ref={ref}>
        <Group>
          {groupsList.map((group) => (
            <Item onClick={() => onSelect(group)} key={group}>
              <BeneficiaryGroupI18n group={group} />
            </Item>
          ))}
        </Group>
      </Container>
    );
  },
);

SelectBeneficiaryGroupV2.displayName = 'SelectPidTypeV2';

const Container = styled.div`
  width: 280px;
  max-height: 686px;
  padding: 4px;
  border-radius: 16px;
  border: 1px solid ${COLORS.systemDark100};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${COLORS.systemLight300};
`;

const Group = styled.div`
  padding: 4px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${COLORS.systemLight100};
`;

const Item = styled.div`
  height: 44px;
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: ${COLORS.systemDark300};

  &:hover {
    background: ${COLORS.systemLight200};
  }
`;
